import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import Tooltip from '../../common/StyledToolTip';
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import styles from '../../../layout/layoutHeader/components/styles';

const LocationToggler = ({ classes, eventHub, setIsDrawerOpen, terminalId }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  useEffect(() => {
    isEnabled && toggleMarkLocation();
  }, [terminalId]);

  const toggleMarkLocation = () => {
    setIsEnabled(!isEnabled);
    eventHub.emit('CustomerLocationMapping', !isEnabled);
    setIsDrawerOpen(!isEnabled);
  };
  return (
    <Tooltip title="Enable/Disable Marked Location">
      <div className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons`}>
        <div className={classes.toggleText}>
          Location Mapping
        </div>
        <ToggleRenderer value={isEnabled} onChange={toggleMarkLocation} />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(LocationToggler);
